import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'
import { PageLayout } from '@/ui/layouts/PageLayout'

export function SwapSkeleton() {
  return (
    <PageLayout>
      <Skeleton className="h-[42px] w-32 sm:h-[60px]" />
      <div className="mx-auto flex w-full max-w-2xl flex-col gap-1.5">
        <Skeleton className="h-[118px] sm:h-[170px]" />
        <Skeleton className="h-[118px] sm:h-[170px]" />
        <Skeleton className="h-[48px]" />
      </div>
    </PageLayout>
  )
}
